<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-simple-table dense style="border: 1px solid #d1d1d1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left caption">GRUPO PADRE</th>
                <th class="text-left caption">TOTAL GRUPO PADRE</th>
                <th class="text-left caption">GRUPO</th>
                <th class="text-right caption">ENERO</th>
                <th class="text-right caption">FEBRERO</th>
                <th class="text-right caption">MARZO</th>
                <th class="text-right caption">ABRIL</th>
                <th class="text-right caption">MAYO</th>
                <th class="text-right caption">JUNIO</th>
                <th class="text-right caption">JULIO</th>
                <th class="text-right caption">AGOSTO</th>
                <th class="text-right caption">SEPTIEMBRE</th>
                <th class="text-right caption">OCTUBRE</th>
                <th class="text-right caption">NOVIEMBRE</th>
                <th class="text-right caption">DICIEMBRE</th>
                <th class="text-right caption">TOTAL GRUPO</th>
              </tr>
            </thead>

            <tbody>
              <template v-for="presupuesto in presupuestosAgrupados">
                <tr v-for="(grupo, index) in presupuesto.grupos" :key="grupo.codigo_grupo">
                  <td v-if="index == 0" :rowspan="presupuesto.grupos.length" class="text-left caption">
                    {{ presupuesto.codigo_grupo_padre }} {{ presupuesto.grupo_padre }}
                  </td>
                  <td v-if="index == 0" :rowspan="presupuesto.grupos.length" class="text-right caption">
                    {{ formatearNumero(presupuesto.grupos.reduce((a, b) => a + Number(b.total_grupo), 0).toFixed(2)) }}
                  </td>
                  <td class="text-left caption">{{ grupo.codigo_grupo }} {{ grupo.grupo }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.enero) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.febrero) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.marzo) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.abril) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.mayo) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.junio) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.julio) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.agosto) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.septiembre) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.octubre) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.noviembre) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.diciembre) }}</td>
                  <td class="text-right caption">{{ formatearNumero(grupo.total_grupo) }}</td>
                </tr>
              </template>

              <tr>
                <td colspan="3" class="text-left caption">TOTAL</td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.enero), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.febrero), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.marzo), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.abril), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.mayo), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.junio), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.julio), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.agosto), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.septiembre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.octubre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.noviembre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.diciembre), 0).toFixed(2)) }}
                </td>
                <td class="text-right caption">
                  {{ formatearNumero(presupuestos.reduce((a, b) => a + Number(b.total_grupo), 0).toFixed(2)) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatearNumero } from './../utils.js';

export default {
  name: 'TablaPresupuestosPorGrupoPorMeses',
  props: {
    presupuestos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    presupuestosAgrupados() {
      const presupuestosAgrupados = {};

      this.presupuestos.forEach((presupuesto) => {
        if (!presupuestosAgrupados[presupuesto.codigo_grupo_padre]) {
          presupuestosAgrupados[presupuesto.codigo_grupo_padre] = {
            codigo_grupo_padre: presupuesto.codigo_grupo_padre,
            grupo_padre: presupuesto.grupo_padre,
            total_grupo_padre: 0,
            grupos: [],
          };
        }

        presupuestosAgrupados[presupuesto.codigo_grupo_padre].grupos.push({
          codigo_grupo: presupuesto.codigo_grupo,
          grupo: presupuesto.grupo,
          enero: Number(presupuesto.enero),
          febrero: Number(presupuesto.febrero),
          marzo: Number(presupuesto.marzo),
          abril: Number(presupuesto.abril),
          mayo: Number(presupuesto.mayo),
          junio: Number(presupuesto.junio),
          julio: Number(presupuesto.julio),
          agosto: Number(presupuesto.agosto),
          septiembre: Number(presupuesto.septiembre),
          octubre: Number(presupuesto.octubre),
          noviembre: Number(presupuesto.noviembre),
          diciembre: Number(presupuesto.diciembre),
          total_grupo: Number(presupuesto.total_grupo),
        });

        presupuestosAgrupados[presupuesto.codigo_grupo_padre].total_grupo_padre += Number(presupuesto.total_grupo);
      });

      return presupuestosAgrupados;
    },
  },
  methods: {
    formatearNumero,
  },
};
</script>